// extracted by mini-css-extract-plugin
module.exports = {"outer":"Modal_outer__b1bGQ","modal":"Modal_modal__P3_V5"};